import {
  useNotify,
  useRecordContext,
  useRefresh,
  BooleanInput,
  Form,
} from "react-admin";
import { Box, Stack, Typography } from "@mui/material";
import { validateAutoSaveSingleInput } from "../../Utils/AutoSave";

const TitleTypeCheckedInput = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Form>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          className="collection-panel__title"
          sx={{ transform: "translateY(1px)" }}
        >
          Confirmed via Title Check?
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            className="collection-panel__title"
            sx={{ fontSize: "14px" }}
          >
            No
          </Typography>

          <BooleanInput
            source="leadContact.vehicle.vehicleDocumentation.titleTypeChecked"
            label="Yes"
            onChange={async (event) =>
              await validateAutoSaveSingleInput(
                record,
                event.target,
                notify,
                refresh
              )
            }
          />
        </Stack>
      </Box>
    </Form>
  );
};

export default TitleTypeCheckedInput;
